import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { clearAllCompany } from '../../store/slice'

export const ConfirmClearAll = ({
  isShow,
  setShow,
  setShowPopupAddCompany,
  setNonePopup,
  isTurnOff,
  clearFunction,
}) => {
  const dispatch = useDispatch()

  const handleConfirm = () => {
    dispatch(clearAllCompany())
    clearFunction && clearFunction()
    if (!isTurnOff) {
      setShowPopupAddCompany(true)
      setShow(false)
    } else {
      setNonePopup(false)
    }
  }

  const handleClose = () => {
    setShow(false)
    setShowPopupAddCompany(true)
  }

  return (
    <>
      <PopupAction
        title="library.detailsPortfolios.DISCARD_CHANGE"
        isShow={isShow}
        handleClose={handleClose}
        btnSubmit={{
          label: 'library.detailsPortfolios.DISCARD',
          isI18n: true,
          event: handleConfirm,
        }}
        btnCancel={{
          label: 'library.filterSetting.CANCEL',
          isI18n: true,
          event: handleClose,
        }}
      >
        <Element elementName="p">
          <Translate value="library.detailsPortfolios.TEXT_DISCARD_TOP" />
        </Element>
        <Element elementName="p">
          <Translate
            value="library.detailsPortfolios.TEXT_DISCARD_BOT"
            dangerousHTML
          />
        </Element>
      </PopupAction>
    </>
  )
}

ConfirmClearAll.propTypes = {
  isShow: PropTypes.bool,
  setShow: PropTypes.func,
  setShowPopupAddCompany: PropTypes.func,
  setNonePopup: PropTypes.func,
  isTurnOff: PropTypes.bool,
}

ConfirmClearAll.defaultProps = {
  setNonePopup: () => {},
  isTurnOff: false,
}
